import { useState, useCallback } from 'react';
import { useMagnetic } from '../lib/motion';
import './Contact.css';

const EMAIL = 'rarespoanta10@gmail.com';

const NEXT = [
  { n: '01', t: 'You write', d: 'One paragraph on the problem. No brief, no forms, no discovery deck.' },
  { n: '02', t: 'I reply in 24h', d: 'With the first real questions and an honest read on fit.' },
  { n: '03', t: 'We map it', d: 'A free 30-minute call, then an architecture sketch and a price range.' },
];

export default function Contact() {
  const [copied, setCopied] = useState(false);
  const mag = useMagnetic(0.2, 12);

  const copy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch {
      window.location.href = `mailto:${EMAIL}`;
    }
  }, []);

  return (
    <section id="contact" className="band ct">
      <div className="ct-aura" aria-hidden="true" />

      <div className="shell ct-inner">
        <span className="avail ct-avail" data-rv="down">
          <i className="avail-led" />
          Available for new projects
        </span>

        <h2 className="ct-title display-xl">
          <span className="mask-line"><span>Tell me what</span></span>
          <span className="mask-line" style={{ '--ml-d': '120ms' }}>
            <span>you&rsquo;re <em>building</em>.</span>
          </span>
        </h2>

        <p className="ct-lede lede" data-rv="up" style={{ '--rv-d': '180ms' }}>
          A product to launch, a system that stopped scaling, or a codebase somebody else
          left behind. Describe it in a paragraph — I will tell you straight whether I am
          the right person for it.
        </p>

        <div className="ct-actions" data-rv="up" style={{ '--rv-d': '260ms' }}>
          <span ref={mag} className="mag">
            <a className="btn btn--volt btn--lg" href={`mailto:${EMAIL}`}>
              Write to me
              <svg className="btn-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="7" y1="17" x2="17" y2="7" /><polyline points="7 7 17 7 17 17" />
              </svg>
            </a>
          </span>

          <button className={`ct-copy ${copied ? 'is-copied' : ''}`} onClick={copy}>
            <span className="ct-copy-text">{EMAIL}</span>
            <span className="ct-copy-ico" aria-hidden="true">
              {copied ? (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="4 12 10 18 20 6" />
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="9" y="9" width="12" height="12" rx="2" /><path d="M5 15V5a2 2 0 0 1 2-2h10" />
                </svg>
              )}
            </span>
            <span className="ct-copy-flag">{copied ? 'Copied' : 'Copy'}</span>
          </button>
        </div>

        <div className="ct-next">
          {NEXT.map((s, i) => (
            <div className="ct-next-item" key={s.n} data-rv="up" style={{ '--rv-d': `${320 + i * 90}ms` }}>
              <span className="ct-next-n">{s.n}</span>
              <span className="ct-next-t">{s.t}</span>
              <span className="ct-next-d">{s.d}</span>
            </div>
          ))}
        </div>

        <div className="ct-meta" data-rv="fade" style={{ '--rv-d': '600ms' }}>
          <span className="mono">Timișoara, RO · remote worldwide</span>
          <span className="ct-meta-sep" />
          <span className="mono">Contracted via AlgorX Software SRL</span>
          <span className="ct-meta-sep" />
          <span className="mono">EN / RO</span>
        </div>
      </div>
    </section>
  );
}
